export const jsonData = {
  books: [
    {
      id: 1,
      title: "All Books",
      chapter: [
        {
          id: 1,
          title: "Lesson 1",
          vocab: [
            {
              romaji: "ano",
              kana: "あの",
              kanji: null,
              english: "um...",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "ima",
              kana: "いま",
              kanji: "今",
              english: "now",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "eigo",
              kana: "えいご",
              kanji: "英語",
              english: "English (language)",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "gakusei",
              kana: "がくせい",
              kanji: "学生",
              english: "student",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "go",
              kana: "...ご",
              kanji: "語",
              english: "...language",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "koukou",
              kana: "こうこう",
              kanji: "高校",
              english: "high school",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "gogo",
              kana: "ごご",
              kanji: "午後",
              english: "P.M.",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "gozen",
              kana: "ごぜん",
              kanji: "午前",
              english: "A.M.",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "sai",
              kana: "...さい",
              kanji: "歳",
              english: "...years old",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "san",
              kana: "...さん",
              kanji: null,
              english: "Mr./Ms. ...",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "ji",
              kana: "...じ",
              kanji: "時",
              english: "...o'clock",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "jin",
              kana: "...じん",
              kanji: "人",
              english: "a person from ...",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "senkou",
              kana: "せんこう",
              kanji: "専攻",
              english: "major/specialty",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "sensei",
              kana: "せんせい",
              kanji: "先生",
              english: "teacher/instructor",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "soudesu",
              kana: "そうです",
              kanji: null,
              english: "that's right",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "soudesuka",
              kana: "そうですか",
              kanji: null,
              english: "I see; Is that so?",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "daigaku",
              kana: "だいがく",
              kanji: "大学",
              english: "college; university",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "denwa",
              kana: "でんわ",
              kanji: "電話",
              english: "telephone",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "tomodachi",
              kana: "ともだち",
              kanji: "友達",
              english: "friend",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "namae",
              kana: "なまえ",
              kanji: "名前",
              english: "name",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "nani",
              kana: "なん／なに",
              kanji: null,
              english: "what",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "nihon",
              kana: "にほん",
              kanji: "日本",
              english: "Japan",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "nensei",
              kana: "...ねんせい",
              kanji: "年生",
              english: "...year student",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "hai",
              kana: "はい",
              kanji: null,
              english: "yes",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "han",
              kana: "はん",
              kanji: "半",
              english: "half",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "bangou",
              kana: "ばんごう",
              kanji: "番号",
              english: "number",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "ryuugakusei",
              kana: "りゅうがくせい",
              kanji: "留学生",
              english: "international student",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "watashi",
              kana: "わたし",
              kanji: "私",
              english: "1st person / I",
              correct: false,
              type: "Vocabulary",
            },
            {
              romaji: "amerika",
              kana: "アメリカ",
              kanji: null,
              english: "U.S.A.",
              correct: false,
              type: "Countries",
            },
            {
              romaji: "igirisu",
              kana: "イギリス",
              kanji: null,
              english: "Britain",
              correct: false,
              type: "Countries",
            },
            {
              romaji: "osutoraria",
              kana: "オーストラリア",
              kanji: null,
              english: "Australia",
              correct: false,
              type: "Countries",
            },
            {
              romaji: "kankoku",
              kana: "かんこく",
              kanji: null,
              english: "Korea",
              correct: false,
              type: "Countries",
            },
            {
              romaji: "suweden",
              kana: "スウェーデン",
              kanji: null,
              english: "Sweden",
              correct: false,
              type: "Countries",
            },
            {
              romaji: "chuugoku",
              kana: "ちゅうごく",
              kanji: "中国",
              english: "China",
              correct: false,
              type: "Countries",
            },
            {
              romaji: "kagaku",
              kana: "かがく",
              kanji: "科学",
              english: "science",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "ajiakenkyuu",
              kana: "アジアけんきゅう",
              kanji: "アジア研究",
              english: "Asian studies",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "keizai",
              kana: "けいざい",
              kanji: "経済",
              english: "economics",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "kokusaikankei",
              kana: "こくさいかんけい",
              kanji: "国際関係",
              english: "international relations",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "konpyuutaa",
              kana: "コンピューター",
              kanji: null,
              english: "computer",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "jinruigaku",
              kana: "じんるいがく",
              kanji: "人類学",
              english: "anthropology",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "seiji",
              kana: "せいじ",
              kanji: "政治",
              english: "politics",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "bijinesu",
              kana: "ビジネス",
              kanji: null,
              english: "business",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "bungaku",
              kana: "ぶんがく",
              kanji: "文学",
              english: "literature",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "rekishi",
              kana: "れきし",
              kanji: "歴史",
              english: "history",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "shigoto",
              kana: "しごと",
              kanji: "仕事",
              english: "job; work; occupation",
              correct: false,
              type: "Occupations",
            },
            {
              romaji: "isha",
              kana: "いしゃ",
              kanji: "医者",
              english: "medical doctor",
              correct: false,
              type: "Occupations",
            },
            {
              romaji: "kaishain",
              kana: "かいしゃいん",
              kanji: "会社員",
              english: "company worker",
              correct: false,
              type: "Occupations",
            },
            {
              romaji: "koukousei",
              kana: "こうこうせい",
              kanji: "高校生",
              english: "high school student",
              correct: false,
              type: "Occupations",
            },
            {
              romaji: "shufu",
              kana: "しゅふ",
              kanji: "主婦",
              english: "housewife",
              correct: false,
              type: "Occupations",
            },
            {
              romaji: "daigakuinsei",
              kana: "だいがくいんせい",
              kanji: "大学院生",
              english: "graduate student",
              correct: false,
              type: "Occupations",
            },
            {
              romaji: "daigakusei",
              kana: "だいがくせい",
              kanji: "大学生",
              english: "college student",
              correct: false,
              type: "Occupations",
            },
            {
              romaji: "bengoshi",
              kana: "べんごし",
              kanji: "弁護士",
              english: "lawyer",
              correct: false,
              type: "Occupations",
            },
            {
              romaji: "okaasan",
              kana: "おかあさん",
              kanji: "お母さん",
              english: "mother",
              correct: false,
              type: "Family",
            },
            {
              romaji: "otousan",
              kana: "おとうさん",
              kanji: "お父さん",
              english: "father",
              correct: false,
              type: "Family",
            },
            {
              romaji: "oneesan",
              kana: "おねえさん",
              kanji: "お姉さん",
              english: "older sister",
              correct: false,
              type: "Family",
            },
            {
              romaji: "oniisan",
              kana: "おにいさん",
              kanji: "お兄さん",
              english: "older brother",
              correct: false,
              type: "Family",
            },
            {
              romaji: "imouto",
              kana: "いもうと",
              kanji: "妹",
              english: "younger sister",
              correct: false,
              type: "Family",
            },
            {
              romaji: "otouto",
              kana: "おとうと",
              kanji: "弟",
              english: "younger brother",
              correct: false,
              type: "Family",
            },
          ],
        },
        {
          id: 2,
          title: "Lesson 2",
          vocab: [
            {
              romaji: "kore",
              kana: "これ",
              kanji: null,
              english: "this one",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "sore",
              kana: "それ",
              kanji: null,
              english: "that one",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "are",
              kana: "あれ",
              kanji: null,
              english: "that one / over there",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "dore",
              kana: "どれ",
              kanji: null,
              english: "which one",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "kono",
              kana: "この",
              kanji: null,
              english: "this …",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "sono",
              kana: "その",
              kanji: null,
              english: "that …",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "ano",
              kana: "あの",
              kanji: null,
              english: "that … over there",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "dono",
              kana: "どの",
              kanji: null,
              english: "which …",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "koko",
              kana: "ここ",
              kanji: null,
              english: "here",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "soko",
              kana: "そこ",
              kanji: null,
              english: "there",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "asoko",
              kana: "あそこ",
              kanji: null,
              english: "over there",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "doko",
              kana: "どこ",
              kanji: null,
              english: "where",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "dare",
              kana: "だれ",
              kanji: null,
              english: "who",
              correct: false,
              type: "Words That Point",
            },
            {
              romaji: "oishii",
              kana: "おいしい",
              kanji: "美味しい",
              english: "delicious",
              correct: false,
              type: "Food",
            },
            {
              romaji: "sakana",
              kana: "さかな",
              kanji: "魚",
              english: "fish",
              correct: false,
              type: "Food",
            },
            {
              romaji: "tonkatsu",
              kana: "とんかつ",
              kanji: null,
              english: "pork cutlet",
              correct: false,
              type: "Food",
            },
            {
              romaji: "niku",
              kana: "にく",
              kanji: "肉",
              english: "meat",
              correct: false,
              type: "Food",
            },
            {
              romaji: "menyu-",
              kana: "メニュー",
              kanji: null,
              english: "menu",
              correct: false,
              type: "Food",
            },
            {
              romaji: "yasai",
              kana: "やさい",
              kanji: "野菜",
              english: "vegetable",
              correct: false,
              type: "Food",
            },
            {
              romaji: "enpitsu",
              kana: "えんぴつ",
              kanji: null,
              english: "pencil",
              correct: false,
              type: "Things",
            },
            {
              romaji: "kasa",
              kana: "かさ",
              kanji: "傘",
              english: "umbrella",
              correct: false,
              type: "Things",
            },
            {
              romaji: "kaban",
              kana: "かばん ",
              kanji: "鞄",
              english: "bag",
              correct: false,
              type: "Things",
            },
            {
              romaji: "kutsu",
              kana: "くつ",
              kanji: "靴",
              english: "shoes",
              correct: false,
              type: "Things",
            },
            {
              romaji: "saifu",
              kana: "さいふ",
              kanji: "財布",
              english: "wallet",
              correct: false,
              type: "Things",
            },
            {
              romaji: "ji-nzu",
              kana: "ジーンズ",
              kanji: null,
              english: "jeans",
              correct: false,
              type: "Things",
            },
            {
              romaji: "jisho",
              kana: "じしょ",
              kanji: "辞書",
              english: "dictionary",
              correct: false,
              type: "Things",
            },
            {
              romaji: "jitensha",
              kana: "じてんしゃ",
              kanji: "自転車",
              english: "bicycle",
              correct: false,
              type: "Things",
            },
            {
              romaji: "shinbun",
              kana: "しんぶん ",
              kanji: "新聞",
              english: "newspaper",
              correct: false,
              type: "Things",
            },
            {
              romaji: "Tshatsu",
              kana: "Tシャツ",
              kanji: null,
              english: "T-shirts",
              correct: false,
              type: "Things",
            },
            {
              romaji: "tokei",
              kana: "とけい",
              kanji: "時計",
              english: "watch; clock",
              correct: false,
              type: "Things",
            },
            {
              romaji: "no-to",
              kana: "ノート",
              kanji: null,
              english: "notebook",
              correct: false,
              type: "Things",
            },
            {
              romaji: "pen",
              kana: "ペン",
              kanji: null,
              english: "pen",
              correct: false,
              type: "Things",
            },
            {
              romaji: "boushi",
              kana: "ぼうし",
              kanji: "帽子",
              english: "hat; cap",
              correct: false,
              type: "Things",
            },
            {
              romaji: "hon",
              kana: "ほん",
              kanji: "本",
              english: "book",
              correct: false,
              type: "Things",
            },
            {
              romaji: "kissaten",
              kana: "きっさてん",
              kanji: "喫茶店",
              english: "café",
              correct: false,
              type: "Places",
            },
            {
              romaji: "ginkou",
              kana: "ぎんこう",
              kanji: "銀行",
              english: "bank",
              correct: false,
              type: "Places",
            },
            {
              romaji: "toire",
              kana: "トイレ",
              kanji: null,
              english: "toilet; restroom",
              correct: false,
              type: "Places",
            },
            {
              romaji: "toshokan",
              kana: "としょかん",
              kanji: "図書館",
              english: "library",
              correct: false,
              type: "Places",
            },
            {
              romaji: "yuubinkyoku",
              kana: "ゆうびんきょく",
              kanji: "郵便局",
              english: "post office",
              correct: false,
              type: "Places",
            },
            {
              romaji: "amerika",
              kana: "アメリカ",
              kanji: "米国",
              english: "U.S.A.",
              correct: false,
              type: "Countries",
            },
            {
              romaji: "igirisu",
              kana: "イギリス",
              kanji: "英国",
              english: "Britain",
              correct: false,
              type: "Countries",
            },
            {
              romaji: "kankoku",
              kana: "かんこく",
              kanji: "韓国",
              english: "Korea",
              correct: false,
              type: "Countries",
            },
            {
              romaji: "chuugoku",
              kana: "ちゅうごく",
              kanji: "中国",
              english: "China",
              correct: false,
              type: "Countries",
            },
            {
              romaji: "keizai",
              kana: "けいざい",
              kanji: "経済",
              english: "economics",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "konpyu-ta-",
              kana: "コンピューター",
              kanji: null,
              english: "computer",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "bijinesu",
              kana: "ビジネス",
              kanji: null,
              english: "business",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "rekishi",
              kana: "れきし",
              kanji: "歴史",
              english: "history",
              correct: false,
              type: "Majors",
            },
            {
              romaji: "okaasan",
              kana: "おかあさん",
              kanji: "お母さん",
              english: "mother",
              correct: false,
              type: "Family",
            },
            {
              romaji: "otousan",
              kana: "おとうさん",
              kanji: "お父さん",
              english: "father",
              correct: false,
              type: "Family",
            },
            {
              romaji: "ikura",
              kana: "いくら",
              kanji: "幾ら",
              english: "how much",
              correct: false,
              type: "Money Matters",
            },
            {
              romaji: "__en",
              kana: "__えん",
              kanji: "円",
              english: "__ JP yen",
              correct: false,
              type: "Money Matters",
            },
            {
              romaji: "takai",
              kana: "たかい",
              kanji: "高い",
              english: "expensive; high",
              correct: false,
              type: "Money Matters",
            },
            {
              romaji: "irasshai",
              kana: "いらっしゃいませ",
              kanji: null,
              english: "Welcome (to our store)",
              correct: false,
              type: "Expressions",
            },
            {
              romaji: "(__o) onegaishimasu",
              kana: "（__を）おねがいします",
              kanji: null,
              english: "..., please",
              correct: false,
              type: "Expressions",
            },
            {
              romaji: "(__o) kudasai",
              kana: "ください",
              kanji: null,
              english: "Please give me ...",
              correct: false,
              type: "Expressions",
            },
            {
              romaji: "jaa",
              kana: "じゃあ",
              kanji: null,
              english: "then...; if that is the case, ...",
              correct: false,
              type: "Expressions",
            },
            {
              romaji: "douzo",
              kana: "どうぞ",
              kanji: null,
              english: "Please.; Here it is.",
              correct: false,
              type: "Expressions",
            },
            {
              romaji: "doumo",
              kana: "どうも",
              kanji: null,
              english: "Thank you.",
              correct: false,
              type: "Expressions",
            },
          ],
        },
        {
          id: 3,
          title: "Lesson 3",
          vocab: [
            {
              kanji: "映画",
              kana: "えいが",
              romaji: "eiga",
              english: "movie",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "音楽",
              kana: "おんがく",
              romaji: "ongaku",
              english: "music",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "雑誌",
              kana: "ざっし",
              romaji: "zasshi",
              english: "magazine",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "スポーツ",
              romaji: "supo-tsu",
              english: "sports",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "デート",
              romaji: "de-to",
              english: "date (romantic, not calendar)",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "テニス",
              romaji: "tenisu",
              english: "tennis",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "テレビ",
              romaji: "terebi",
              english: "TV",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "アイスクリーム",
              romaji: "aisukuri-mu",
              english: "ice cream",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "朝ご飯",
              kana: "あさごはん",
              romaji: "asagohan",
              english: "breakfast",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お酒",
              kana: "おさけ",
              romaji: "osake",
              english: "sake; alcohol",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お茶",
              kana: "おちゃ",
              romaji: "ocha",
              english: "grean tea",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "コーヒー",
              romaji: "ko-hi-",
              english: "coffee",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "晩ご飯",
              kana: "ばんごはん",
              romaji: "bangohan",
              english: "dinner",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "水",
              kana: "みず",
              romaji: "mizu",
              english: "water",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ハンバーガー",
              romaji: "hanba-ga-",
              english: "hamburger",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "昼ご飯",
              kana: "ひるごはん",
              romaji: "hirugohan",
              english: "lunch",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "家",
              kana: "いえ",
              romaji: "ie",
              english: "home; house",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "うち",
              romaji: "uchi",
              english: "home; house; my place",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "学校",
              kana: "がっこう",
              romaji: "gakkou",
              english: "school",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "朝",
              kana: "あさ",
              romaji: "asa",
              english: "morning",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "明日",
              kana: "あした",
              romaji: "ashita",
              english: "tomorrow",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "いつ",
              romaji: "itsu",
              english: "when",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "今日",
              kana: "きょう",
              romaji: "kyou",
              english: "today",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "~ごろ",
              romaji: "___goro",
              english: "at about…",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "今晩",
              kana: "こんばん",
              romaji: "konban",
              english: "tonight",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "週末",
              kana: "しゅうまつ",
              romaji: "shuumatsu",
              english: "weekend",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "土曜日",
              kana: "どようび",
              romaji: "doyoubi",
              english: "Saturday",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "日曜日",
              kana: "にちようび",
              romaji: "nichiyoubi",
              english: "Sunday",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "毎日",
              kana: "まいにち",
              romaji: "mainichi",
              english: "every day",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "毎晩",
              kana: "まいばん",
              romaji: "maiban",
              english: "every night",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "行く",
              kana: "いく",
              romaji: "iku",
              english: "to go (destination に/へ)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "帰る",
              kana: "かえる",
              romaji: "kaeru",
              english: "to go back; to return (destination に/へ)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "聞く",
              kana: "きく",
              romaji: "kiku",
              english: "to listen; to hear (~を）",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "飲む",
              kana: "のむ",
              romaji: "nomu",
              english: "to drink (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "話す",
              kana: "はなす",
              romaji: "hanasu",
              english: "to speak; to talk (language を/で)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "読む",
              kana: "よむ",
              romaji: "yomu",
              english: "to read (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "起きる",
              kana: "おきる",
              romaji: "okiru",
              english: "to get up",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "食べる",
              kana: "たべる",
              romaji: "taberu",
              english: "to eat (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "寝る",
              kana: "ねる",
              romaji: "neru",
              english: "to sleep; to go to sleep",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "見る",
              kana: "みる",
              romaji: "miru",
              english: "to see;  to look at;  to watch (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "来る",
              kana: "くる",
              romaji: "kuru",
              english: "to come (destination に/へ)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "する",
              romaji: "suru",
              english: "to do (~を)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "勉強する",
              kana: "べんきょうする",
              romaji: "benkyousuru",
              english: "to study (~を)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "いい",
              romaji: "ii",
              english: "good",
              type: "Adjectives",
              correct: false,
            },
            {
              kanji: "早い",
              kana: "はやい",
              romaji: "hayai",
              english: "early",
              type: "Adjectives",
              correct: false,
            },
            {
              kanji: null,
              kana: "あまり + negative",
              romaji: "amari",
              english: "not much",
              type: "Adverbs",
              correct: false,
            },
            {
              kanji: "全然",
              kana: "ぜんぜん + negative",
              romaji: "zenzen",
              english: "not at all",
              type: "Adverbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "たいてい",
              romaji: "taitei",
              english: "usually",
              type: "Adverbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "ちょっと",
              romaji: "chotto",
              english: "a little",
              type: "Adverbs",
              correct: false,
            },
            {
              kanji: "時々",
              kana: "ときどき",
              romaji: "tokidoki",
              english: "sometimes",
              type: "Adverbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "よく",
              romaji: "yoku",
              english: "often; much",
              type: "Adverbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "そうですね",
              romaji: "soudesune",
              english: "That's right.; Let me see.",
              type: "Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "でも",
              romaji: "demo",
              english: "but",
              type: "Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "どうですか",
              romaji: "doudesuka",
              english: "How about…?; How is …?",
              type: "Expressions",
              correct: false,
            },
          ],
        },
        {
          id: 4,
          title: "Lesson 4",
          vocab: [
            {
              kanji: null,
              kana: "アルバイト",
              romaji: "arubaito",
              english: "part-time job",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "買い物",
              kana: "かいもの",
              romaji: "kaimono",
              english: "shopping",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "クラス",
              romaji: "kurasu",
              english: "class",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "あなた",
              romaji: "anata",
              english: "you",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "いす",
              romaji: "isu",
              english: "chair",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "犬",
              romaji: "inu",
              english: "dog",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お土産",
              kana: "おみやげ",
              romaji: "omiyage",
              english: "souvenir",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "子供",
              kana: "こども",
              romaji: "kodomo",
              english: "child",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "ご飯",
              kana: "ごはん",
              romaji: "gohan",
              english: "rice; meal",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "写真",
              kana: "しゃしん",
              romaji: "shashin",
              english: "picture; photograph",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "机",
              kana: "つくえ",
              romaji: "tsukue",
              english: "desk",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "手紙",
              kana: "てがみ",
              romaji: "tegami",
              english: "letter",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "猫",
              kana: "ねこ",
              romaji: "neko",
              english: "cat",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "パン",
              romaji: "pan",
              english: "bread",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "人",
              kana: "ひと",
              romaji: "hito",
              english: "person",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "メール",
              romaji: "me-ru",
              english: "e-mail",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お寺",
              kana: "おてら",
              romaji: "otera",
              english: "temple",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "公園",
              kana: "こうえん",
              romaji: "kouen",
              english: "park",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "スーパー",
              romaji: "su-pa-",
              english: "supermarket",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "デパート",
              romaji: "depa-to",
              english: "department store",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "バス停",
              kana: "バスてい",
              romaji: "basutei",
              english: "bus stop",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "病院",
              kana: "びょういん",
              romaji: "byouin",
              english: "hospital",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ホテル",
              romaji: "hoteru",
              english: "hotel",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "本屋",
              kana: "ほんや",
              romaji: "honya",
              english: "bookstoore",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "町",
              kana: "まち",
              romaji: "machi",
              english: "town; city",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "レストラン",
              romaji: "resutoran",
              english: "restaurant",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "昨日",
              kana: "きのう",
              romaji: "kinou",
              english: "yesterday",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "~時間",
              kana: "~じかん",
              romaji: "~jikan",
              english: "...hours",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "先週",
              kana: "せんしゅう",
              romaji: "senshuu",
              english: "last week",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "時",
              kana: "とき",
              romaji: "toki",
              english: "when…; at the time of … （~の）",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "月曜日",
              kana: "げつようび",
              romaji: "getsuyoubi",
              english: "Monday",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "火曜日",
              kana: "かようび",
              romaji: "kayoubi",
              english: "Tuesday",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "水曜日",
              kana: "すいようび",
              romaji: "suiyoubi",
              english: "Wednesday",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "木曜日",
              kana: "もくようび",
              romaji: "mokuyoubi",
              english: "Thursday",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "金曜日",
              kana: "きんようび",
              romaji: "kinyoubi",
              english: "Friday",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "会う",
              kana: "あう",
              romaji: "au",
              english: "to meet; see (a person) ( person に)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "ある",
              romaji: "aru",
              english: "There is... (place に thing が)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "買う",
              kana: "かう",
              romaji: "kau",
              english: "to buy (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "書く",
              kana: "かく",
              romaji: "kaku",
              english: "to write （person に　thing を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "撮る",
              kana: "とる",
              romaji: "toru",
              english: "to take (a pcture) (~を）",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "待つ",
              kana: "まつ",
              romaji: "matsu",
              english: "to wait （~を）",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "わかる",
              romaji: "wakaru",
              english: "to understand (~が)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "いる",
              romaji: "iru",
              english: "（a person) is in …; stays at … (place に person が）",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "~ぐらい",
              romaji: "~gurai",
              english: "about (approximate measurement)",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "ごめんなさい ",
              romaji: "gomennasai",
              english: "I'm sorry.",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "だから",
              romaji: "dakara",
              english: "so; therefore",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "たくさん",
              romaji: "takusan",
              english: "many; a lot",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "~と",
              romaji: "~to",
              english: "together with (a person)",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "どうして",
              romaji: "doushite",
              english: "why",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "一人で",
              kana: "ひとりで",
              romaji: "hitoride",
              english: "alone",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
          ],
        },
        {
          id: 5,
          title: "Lesson 5",
          vocab: [
            {
              kanji: "海",
              kana: "うみ",
              romaji: "umi",
              english: "sea",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "切手",
              kana: "きって",
              romaji: "kitte",
              english: "postal stamp",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "切符",
              kana: "きっぷ",
              romaji: "kippu",
              english: "ticket",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "サーフィン",
              romaji: "sa-fin",
              english: "surfing",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "宿題",
              kana: "しゅくだい",
              romaji: "shukudai",
              english: "homework",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "食べ物",
              kana: "たべもの",
              romaji: "tabemono",
              english: "food",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "誕生日",
              kana: "たんじょうび",
              romaji: "tanjoubi",
              english: "birthday",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "テスト",
              romaji: "tesuto",
              english: "test",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "天気",
              kana: "てんき",
              romaji: "tenki",
              english: "weather",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "飲み物",
              kana: "のみもの",
              romaji: "nomimono",
              english: "drink",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "葉書",
              kana: "はがき",
              romaji: "hagaki",
              english: "postcard",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "バス",
              romaji: "basu",
              english: "bus",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "飛行機",
              kana: "ひこうき",
              romaji: "hikouki",
              english: "airplane",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "部屋",
              kana: "へや",
              romaji: "heya",
              english: "room",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "僕",
              kana: "ぼく",
              romaji: "boku",
              english: "I (used by men)",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "休み",
              kana: "やすみ",
              romaji: "yasumi",
              english: "holiday; day off; absence",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "旅行",
              kana: "りょこう",
              romaji: "ryokou",
              english: "travel",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "新しい",
              kana: "あたらしい",
              romaji: "atarashii",
              english: "new",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "暑い",
              kana: "あつい",
              romaji: "atsui",
              english: "hot (weather)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "忙しい",
              kana: "いそがしい",
              romaji: "isogashii",
              english: "busy (people/days)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "大きい",
              kana: "おおきい",
              romaji: "ookii",
              english: "large",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "面白い",
              kana: "おもしろい",
              romaji: "omoshiroi",
              english: "interesting; funny",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: null,
              kana: "かっこいい",
              romaji: "kakkoii",
              english: "good-looking (conjugates like いい)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "怖い",
              kana: "こわい",
              romaji: "kowai",
              english: "frightening",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "寒い",
              kana: "さむい",
              romaji: "samui",
              english: "cold (weather-not used for things)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "楽しい",
              kana: "たのしい",
              romaji: "tanoshii",
              english: "fun",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "小さい",
              kana: "ちいさい",
              romaji: "chiisai",
              english: "small",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: null,
              kana: "つまらない",
              romaji: "tsumanarai",
              english: "boring",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "古い",
              kana: "ふるい",
              romaji: "furui",
              english: "old (thing-not used for people)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "難しい",
              kana: "むずかしい",
              romaji: "muzukashii",
              english: "difficult",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: null,
              kana: "やさしい",
              romaji: "yasashii",
              english: "easy (problem) ; kind (person)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "安い",
              kana: "やすい",
              romaji: "yasui",
              english: "inexpensive; cheap (thing)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "嫌い",
              kana: "きらい(な)",
              romaji: "kirai(na)",
              english: "disgusted with; to dislike (~が)",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: null,
              kana: "きれい(な)",
              romaji: "kirei(na)",
              english: "beautiful; clean",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "元気",
              kana: "げんき(な)",
              romaji: "genki(na)",
              english: "healthy; energetic",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "静か",
              kana: "しずか(な)",
              romaji: "shizuka(na)",
              english: "quiet",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "好き",
              kana: "すき(な)",
              romaji: "suki(na)",
              english: "found of; to like (~が)",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "大嫌い",
              kana: "だいきらい(な)",
              romaji: "daikirai(na)",
              english: "to hate (~が)",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "大好き",
              kana: "だいすき(な)",
              romaji: "daisuki(na)",
              english: "very found of; to love (~が)",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: null,
              kana: "にぎやか(な)",
              romaji: "nigiyaka(na)",
              english: "lively",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "暇",
              kana: "ひま(な)",
              romaji: "hima(na)",
              english: "not busy; to have a lot of free time",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "泳ぐ",
              kana: "およぐ",
              romaji: "oyogu",
              english: "to swim",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "聞く",
              kana: "きく",
              romaji: "kiku",
              english: "to ask (person に)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "乗る",
              kana: "のる",
              romaji: "noru",
              english: "to ride; to board (~に)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "やる",
              romaji: "yaru",
              english: "to do; to perform (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "出かける",
              kana: "でかける",
              romaji: "dekakeru",
              english: "to go out",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "一緒に",
              kana: "いっしょに",
              romaji: "isshoni",
              english: "together",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "すごく",
              romaji: "sugoku",
              english: "extremely",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "それから",
              romaji: "sorekara",
              english: "and then",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "大丈夫",
              kana: "だいじょうぶ",
              romaji: "daijoubu",
              english:
                "It's okay.; Not to worry.; Everything is under control.",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "とても",
              romaji: "totemo",
              english: "very",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "どんな",
              romaji: "donna",
              english: "what kind of…",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "~枚",
              romaji: "~mai",
              english: "[counter for flat objects]",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "~まで",
              romaji: "~made",
              english: "to (a place); as far as (a place); till (a time)",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
          ],
        },
        {
          id: 6,
          title: "Lesson 6",
          vocab: [
            {
              kanji: "お金",
              kana: "おかね",
              romaji: "okane",
              english: "money",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お風呂",
              kana: "おふろ",
              romaji: "ofuro",
              english: "bath",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "漢字",
              kana: "かんじ",
              romaji: "kanji",
              english: "kanji; Chinese character",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "教科書",
              kana: "きょうかしょ",
              romaji: "kyoukasho",
              english: "textbook",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "今週",
              kana: "こんしゅう",
              romaji: "konshuu",
              english: "this week",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "CD",
              kana: "シーディー",
              romaji: "shi-dhi-",
              english: "CD",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "市民病院",
              kana: "しみんびょういん",
              romaji: "shiminbyouin",
              english: "municipal hospital",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "シャワー",
              romaji: "shawa-",
              english: "shower",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "次",
              kana: "つぎ",
              romaji: "tsugi",
              english: "next",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "電気",
              kana: "でんき",
              romaji: "denki",
              english: "electricity",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "電車",
              kana: "でんしゃ",
              romaji: "densha",
              english: "train",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "荷物",
              kana: "にもつ",
              romaji: "nimotsu",
              english: "baggage",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "パソコン",
              romaji: "pasokon",
              english: "personal computer",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ページ",
              romaji: "pe-ji",
              english: "page",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "窓",
              kana: "まど",
              romaji: "mado",
              english: "window",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "夜",
              kana: "よる",
              romaji: "yoru",
              english: "night",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "来週",
              kana: "らいしゅう",
              romaji: "raishuu",
              english: "next week",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "来年",
              kana: "らいねん",
              romaji: "rainen",
              english: "next year",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "大変",
              kana: "たいへん(な)",
              romaji: "taihen(na)",
              english: "tough (situation)",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "遊ぶ",
              kana: "おそぶ",
              romaji: "osobu",
              english: "to play, to spend time pleasantly",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "急ぐ",
              kana: "いそぐ",
              romaji: "isogu",
              english: "to hurry",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "お風呂に入る",
              kana: "おふろにはいる",
              romaji: "ofuro ni hairu",
              english: "to take a bath",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "返す",
              kana: "かえす",
              romaji: "kaesu",
              english: "to return (a thing)　 (person に thing を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "消す",
              kana: "けす",
              romaji: "kesu",
              english: "to turn off; to erase (~を）",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "死ぬ",
              kana: "しぬ",
              romaji: "shinu",
              english: "to die",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "座る",
              kana: "すわる",
              romaji: "suwaru",
              english: "to sit down (seat に）",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "立つ",
              kana: "たつ",
              romaji: "tatsu",
              english: "to stand up",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "たばこを吸う",
              kana: "たばこをすう",
              romaji: "tabako o suu",
              english: "to smoke",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "使う",
              kana: "つかう",
              romaji: "tsukau",
              english: "to use (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "手伝う",
              kana: "てつだう",
              romaji: "tetsudau",
              english: "to help (person/task を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "入る",
              kana: "はいる",
              romaji: "hairu",
              english: "to enter (~に)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "持つ",
              kana: "もつ",
              romaji: "motsu",
              english: "to carry; to hold (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "休む",
              kana: "やすむ",
              romaji: "yasumu",
              english: "(1) to be absent (from...）(~を)  (2) to rest",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "開ける",
              kana: "あける",
              romaji: "akeru",
              english: "to open (something) (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "教える",
              kana: "おしえる",
              romaji: "oshieru",
              english: "to teach; to instruct (person に thing を）",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "降りる",
              kana: "おりる",
              romaji: "oriru",
              english: "to get off (~を）",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "借りる",
              kana: "かりる",
              romaji: "kariru",
              english: "to borrow (person に thing を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "閉める",
              kana: "しめる",
              romaji: "shimeru",
              english: "to close (something) (~を）",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "シャワーを浴びる",
              kana: "シャワーをあびる",
              romaji: "shawa- o abiru",
              english: "to take a shower",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "つける",
              romaji: "tsukeru",
              english: "to turn on (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "電話をかける",
              kana: "でんわをかける",
              romaji: "denwa o kakeru",
              english: "to make a phone call (~に)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "忘れる",
              kana: "わすれる",
              romaji: "wasureru",
              english: "to forget; to leave behind (~を）",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "連れてくる",
              kana: "つれてくる",
              romaji: "tsuretekuru",
              english: "to bring (a person) (~を）",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "持ってくる",
              kana: "もってくる",
              romaji: "mottekuru",
              english: "to bring (a thing) (~を）",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "後で",
              kana: "あとで",
              romaji: "atode",
              english: "later on",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "遅く",
              kana: "おそく",
              romaji: "osoku",
              english: "(do something) late",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "~から",
              romaji: "~kara",
              english: "because...",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "結構です",
              kana: "けっこうです",
              romaji: "kekkoudesu",
              english: "That would be fine; That wouldn't be necessary",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "すぐ",
              romaji: "sugu",
              english: "right away",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "本当ですか",
              kana: "ほんとうですか",
              romaji: "hontoudesuka",
              english: "Really?",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "ゆっくり",
              romaji: "yukkuri",
              english: "slowly; leisurely; unhurriedly",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
          ],
        },
        {
          id: 7,
          title: "Lesson 7",
          vocab: [
            {
              kanji: "姉",
              kana: "あね",
              romaji: "ane",
              english: "(my) older sister",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "アパート",
              romaji: "apa-to",
              english: "apartment",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "妹",
              kana: "いもうと",
              romaji: "imouto",
              english: "younger sister",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "歌",
              kana: "うた",
              romaji: "uta",
              english: "song",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "おじいさん",
              romaji: "ojiisan",
              english: "grandfather; old man",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "弟",
              kana: "おとうと",
              romaji: "otouto",
              english: "younger brother",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "男の人",
              kana: "おとこのひと",
              romaji: "otokonohito",
              english: "man",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お兄さん",
              kana: "おにいさん",
              romaji: "oniisan",
              english: "older brother",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お姉さん",
              kana: "おねえさん",
              romaji: "oneesan",
              english: "older sister",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "おばあさん",
              romaji: "obaasan",
              english: "grandmother; old woman",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "女の人",
              kana: "おんなのひと",
              romaji: "onnnanohito",
              english: "woman",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "会社",
              kana: "かいしゃ",
              romaji: "kaisha",
              english: "company",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "家族",
              kana: "かぞく",
              romaji: "kazoku",
              english: "family",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "髪",
              kana: "かみ",
              romaji: "kami",
              english: "hair",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "兄弟",
              kana: "きょうだい",
              romaji: "kyoudai",
              english: "brothers and sisters",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "口",
              kana: "くち",
              romaji: "kuchi",
              english: "mouth",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "国",
              kana: "くに",
              romaji: "kuni",
              english: "country; place of origin",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "車",
              kana: "くるま",
              romaji: "kuruma",
              english: "car",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ゲーム",
              romaji: "ge-mu",
              english: "game",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "コンビニ",
              romaji: "konbini",
              english: "convenience store",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "サークル",
              romaji: "sa-kuru",
              english: "club activity",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "食堂",
              kana: "しょくどう",
              romaji: "shokudou",
              english: "cafeteria; dining commons",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "父",
              kana: "ちち",
              romaji: "chichi",
              english: "(my) father",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "DVD",
              kana: "ディーブイディー",
              romaji: "DVD",
              english: "DVD",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "母",
              kana: "はは",
              romaji: "haha",
              english: "(my) mother",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "目",
              kana: "め",
              romaji: "me",
              english: "eye",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "眼鏡",
              kana: "めがね",
              romaji: "megane",
              english: "glasses",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "頭がいい",
              kana: "あたまがいい",
              romaji: "atamagaii",
              english: "bright; smart; clever (conjugates like いい)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: null,
              kana: "かわいい",
              romaji: "kawaii",
              english: "cute",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "背が高い",
              kana: "せがたかい",
              romaji: "se ga takai",
              english: "tall (stature)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "背が低い",
              kana: "せがひくい",
              romaji: "se ga hikui",
              english: "short (stature)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "長い",
              kana: "ながい",
              romaji: "nagai",
              english: "long",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "速い",
              kana: "はやい",
              romaji: "hayai",
              english: "fast",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "短い",
              kana: "みじかい",
              romaji: "mijikai",
              english: "short (length)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "親切",
              kana: "しんせつ(な)",
              romaji: "shinsetsu(na)",
              english: "kind",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "便利",
              kana: "べんり(な)",
              romaji: "benri(na)",
              english: "convenient",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "歌う",
              kana: "うたう",
              romaji: "utau",
              english: "to sing (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "かぶる",
              romaji: "kaburu",
              english: "to put on (a hat) (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "しる",
              romaji: "shiru",
              english: "to get to know (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "知っています",
              kana: "しっています",
              romaji: "shitteimasu",
              english: "I know",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "知りません",
              kana: "しりません",
              romaji: "shirimasen",
              english: "I do not know",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "住む",
              kana: "すむ",
              romaji: "sumu",
              english: "to live (~にすんでいます)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "はく",
              romaji: "haku",
              english: "to put on (items below your waist) (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "太る",
              kana: "ふとる",
              romaji: "futoru",
              english: "to gain weight",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "太っています",
              kana: "ふとっています",
              romaji: "futotteimasu",
              english: "to be on the heavy side",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "(めがねを) かける",
              romaji: "(megane o) kakeru",
              english: "to put on (glasses)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "着る",
              kana: "きる",
              romaji: "kiru",
              english: "to put on (clothes above your waist) (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "勤める",
              kana: "つとめる",
              romaji: "tsutomeru",
              english: "to work for (~につとめています)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "やせる",
              romaji: "yaseru",
              english: "to lose weight",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "やせています",
              romaji: "yaseteimasu",
              english: "to be thin",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "結婚する",
              kana: "けっこんする",
              romaji: "kekkonsuru",
              english: "to get married (~と)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "~が",
              romaji: "~ga",
              english: "..., but",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "何も",
              kana: "なにも",
              romaji: "nani mo + negative",
              english: "not...anything",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "~人",
              kana: "~にん",
              romaji: "~nin",
              english: "[counter for people]",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "一人",
              kana: "ひとり",
              romaji: "hitori",
              english: "two people",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "二人",
              kana: "ふたり",
              romaji: "futari",
              english: "nothing in partcular",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "別に",
              kana: "べつに + negative",
              romaji: "betsu ni",
              english: "nothing in particular",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "もしもし",
              romaji: "moshimoshi",
              english: "Hello? (used on the phone)",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "もちろん",
              romaji: "mochiron",
              english: "of course",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "よかったら",
              romaji: "yokattara",
              english: "If you like",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
          ],
        },
        {
          id: 8,
          title: "Lesson 8",
          vocab: [
            {
              kanji: null,
              kana: "あさって",
              romaji: "asatte",
              english: "The day after tomorrow",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "雨",
              kana: "あめ",
              romaji: "ame",
              english: "rain",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "会社員",
              kana: "かいしゃいん",
              romaji: "kaishain",
              english: "office worker",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "カメラ",
              romaji: "kamera",
              english: "camera",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "カラオケ",
              romaji: "karaoke",
              english: "karaoke",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "空気",
              kana: "くうき",
              romaji: "kuuki",
              english: "air",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "今朝",
              kana: "けさ",
              romaji: "kesa",
              english: "this morning",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "黒板",
              kana: "こくばん",
              romaji: "kokuban",
              english: "blackboard",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "今月",
              kana: "こんげつ",
              romaji: "kongetsu",
              english: "this month",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "仕事",
              kana: "しごと",
              romaji: "shigoto",
              english: "job; work; occupation",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "大学生",
              kana: "だいがくせい",
              romaji: "daigakusei",
              english: "college student",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "天気予報",
              kana: "てんきよほう",
              romaji: "tenkiyohou",
              english: "weather forecast",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "所",
              kana: "ところ",
              romaji: "tokoro",
              english: "place",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "トマト",
              romaji: "tomato",
              english: "tomato",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "夏",
              kana: "なつ",
              romaji: "natsu",
              english: "summer",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "何か",
              kana: "なにか",
              romaji: "nanika",
              english: "something",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "パーティー",
              romaji: "pa-ti-",
              english: "party",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "バーベキュー",
              romaji: "ba-bekyu-",
              english: "barbecue",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "はし",
              romaji: "hashi",
              english: "chopsticks",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "冬",
              kana: "ふゆ",
              romaji: "fuyu",
              english: "winter",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ホームステイ",
              romaji: "ho-musutei",
              english: "homestay; living with a local family",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "毎週",
              kana: "まいしゅう",
              romaji: "maishuu",
              english: "every week",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "来月",
              kana: "らいげつ",
              romaji: "raigetsu",
              english: "next month",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "上手",
              kana: "じょうず(な)",
              romaji: "jouzu(na)",
              english: "skillful; good at...(~が)",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "下手",
              kana: "へた(な)",
              romaji: "heta(na)",
              english: "clumsy; poor at... (が)",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "有名",
              kana: "ゆうめい(な)",
              romaji: "yuumei(na)",
              english: "famous",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "雨が 降る",
              kana: "あめがふる",
              romaji: "ame ga furu",
              english: "it rains",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "洗う",
              kana: "あらう",
              romaji: "arau",
              english: "to wash (~を）",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "言う",
              kana: "いう",
              romaji: "iu",
              english: "to say",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "いる",
              romaji: "iru",
              english: "to need (~が)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "遅くなる",
              kana: "おそくなる",
              romaji: "osoku naru",
              english: "to be late",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "思う",
              kana: "おもう",
              romaji: "omou",
              english: "to think",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "切る",
              kana: "きる",
              romaji: "kiru",
              english: "to cut (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "作る",
              kana: "つくる",
              romaji: "tsukuru",
              english: "to make (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "持っていく",
              kana: "もっていく",
              romaji: "motteiku",
              english: "to take (a thing ~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "じろじろ見る",
              kana: "じろじろみる",
              romaji: "jirojiro miru",
              english: "to stare (at...) (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "捨てる",
              kana: "すてる",
              romaji: "suteru",
              english: "to throw away (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "始める",
              kana: "はじめる",
              romaji: "hajimeru",
              english: "to begin (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "運転する",
              kana: "うんてんする",
              romaji: "untensuru",
              english: "to drive (~を)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "洗濯する",
              kana: "せんたくする",
              romaji: "sentakusuru",
              english: "to do laundry (~を)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "掃除する",
              kana: "そうじする",
              romaji: "soujisuru",
              english: "to clean (~を)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "電話する",
              kana: "でんわする",
              romaji: "denwasuru",
              english: "to call (~に)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "料理する",
              kana: "りょうりする",
              romaji: "ryourisuru",
              english: "to cook",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "いつも",
              romaji: "itsumo",
              english: "always",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "ううん",
              romaji: "uun",
              english: "uh-uh; no",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "うん",
              romaji: "un",
              english: "uh-huh; yes",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "乾杯",
              kana: "かんぱい",
              romaji: "kanpai",
              english: "Cheers! (a toast)",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "残念(ですね)",
              kana: "ざんねん(ですね)",
              romaji: "zannen(desune)",
              english: "That's too bad.",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "~について",
              romaji: "~ni tsuite",
              english: "about...; concerning...",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "まだ + negative",
              romaji: "mada",
              english: "not...yet",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "みんなで",
              romaji: "minnade",
              english: "all (of the people) together",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "カレーライス",
              romaji: "kare-raisu",
              english: "curry with rice",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "えびフライ",
              romaji: "ebifurai",
              english: "Deep-fied shrimp",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "ラーメン",
              romaji: "ra-men",
              english: "Ramen noodles",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "うどん",
              romaji: "udon",
              english: "Udon noodles",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "スパゲッティ",
              romaji: "supagetti-",
              english: "Spaghetti",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "ぎょうざ",
              romaji: "gyouza",
              english: "Gyoza Dumplings",
              type: "Food",
              correct: false,
            },
            {
              kanji: "牛丼",
              kana: "ぎゅうどん",
              romaji: "gyuunyuu",
              english: "Beef rice bowl",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "ハンバーグ",
              romaji: "hanba-gu",
              english: "Hamburger steak",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "さしみ",
              romaji: "sashimi",
              english: "Aaw seafood",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "お好み焼き",
              romaji: "okonomiyaki",
              english: "Savory pancake",
              type: "Food",
              correct: false,
            },
            {
              kanji: "ご飯",
              kana: "ごはん",
              romaji: "gohan",
              english: "Rice; meal",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "おかず",
              romaji: "okazu",
              english: "Side dish; Dish that comes with rice",
              type: "Food",
              correct: false,
            },
            {
              kanji: "みそ汁",
              kana: "みそしる",
              romaji: "misoshiru",
              english: "Miso soup",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "トースト",
              romaji: "to-suto",
              english: "Toast bread",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "スープ",
              romaji: "su-pu",
              english: "Soup",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "ヨーグルト",
              romaji: "yo-guruto",
              english: "Yogurt",
              type: "Food",
              correct: false,
            },
            {
              kanji: "焼き魚",
              kana: "やきざかな",
              romaji: "yakizakana",
              english: "Broiled fish",
              type: "Food",
              correct: false,
            },
            {
              kanji: null,
              kana: "たまご",
              romaji: "tamago",
              english: "Egg",
              type: "Food",
              correct: false,
            },
          ],
        },
        {
          id: 9,
          title: "Lesson 9",
          vocab: [
            {
              kanji: "いい子",
              kana: "いいこ",
              romaji: "iiko",
              english: "good child",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "色",
              kana: "いろ",
              romaji: "iro",
              english: "color",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お弁当",
              kana: "おべんとう",
              romaji: "obentou",
              english: "boxed lunch",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "歌舞伎",
              kana: "かぶき",
              romaji: "kabuki",
              english: "kabuki; traditional Japanese theatrical art",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ギター",
              romaji: "gita-",
              english: "guitar",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "去年",
              kana: "きょねん",
              romaji: "kyonen",
              english: "last year",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "薬",
              kana: "くすり",
              romaji: "kusuri",
              english: "medicine",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "薬を飲む",
              kana: "くすりをのむ",
              romaji: "kusuri o nomu",
              english: "to take medicine",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "コンサート",
              romaji: "konsa-to",
              english: "concert",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "今度",
              kana: "こんど",
              romaji: "kondo",
              english: "near future",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "作文",
              kana: "さくぶん",
              romaji: "sakubun",
              english: "essay; composition",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "試験",
              kana: "しけん",
              romaji: "shiken",
              english: "exam",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "スキー",
              romaji: "suki-",
              english: "ski",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "先月",
              kana: "せんげつ",
              romaji: "sengetsu",
              english: "last month",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "単語",
              kana: "たんご",
              romaji: "tango",
              english: "word; vocabulary",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ピアノ",
              romaji: "piano",
              english: "piano",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ピザ",
              romaji: "piza",
              english: "pizza",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "病気",
              kana: "びょうき",
              romaji: "byouki",
              english: "illness; sickness",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "緑",
              kana: "みどり / グリーン",
              romaji: "midori",
              english: "green",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "灰色",
              kana: "はいいろ / グレー",
              romaji: "haiiro",
              english: "gray",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ピンク",
              romaji: "pinku",
              english: "pink",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "銀色",
              kana: "ぎんいろ / シルバー",
              romaji: "giniro",
              english: "silver",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "紫",
              kana: "むらさき",
              romaji: "murasaki",
              english: "purple",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "水色",
              kana: "みずいろ",
              romaji: "mizuiro",
              english: "light blue",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "金色",
              kana: "きんいろ / ゴールド",
              romaji: "kiniro",
              english: "gold",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "金髪",
              kana: "きんぱつ",
              romaji: "kinpatsu",
              english: "blonde hair",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "白黒の写真",
              kana: "しろくろのしゃしん",
              romaji: "shirokuro no shashin",
              english: "black and white picture",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "青い",
              kana: "あおい",
              romaji: "aoi",
              english: "blue",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "赤い",
              kana: "あかい",
              romaji: "akai",
              english: "red",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "黒い",
              kana: "くろい",
              romaji: "kuroi",
              english: "black",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "寂しい",
              kana: "さびしい",
              romaji: "sabishii",
              english: "lonely",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "白い",
              kana: "しろい",
              romaji: "shiroi",
              english: "white",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "茶色い",
              kana: "ちゃいろい",
              romaji: "chairoi",
              english: "brown",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "黄色い",
              kana: "きいろい",
              romaji: "kiiroi",
              english: "yellow",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "若い",
              kana: "わかい",
              romaji: "wakai",
              english: "young",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "意地悪",
              kana: "いじわる(な)",
              romaji: "ijiwarui(na)",
              english: "mean-spirited",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "顔が青い",
              kana: "かおがあおい",
              romaji: "kaogaaoi",
              english: "to look pale",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "踊る",
              kana: "おどる",
              romaji: "odoru",
              english: "to dance",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "終わる",
              kana: "おわる",
              romaji: "owaru",
              english: "(something) ends (~が)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "人気がある",
              kana: "にんきがある",
              romaji: "ninki ga aru",
              english: "to be popular",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "始まる",
              kana: "はじまる",
              romaji: "hajimaru",
              english: "(something) begins (~が)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "弾く",
              kana: "ひく",
              romaji: "hiku",
              english: "to play (a string instrument/piano) (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "もらう",
              romaji: "morau",
              english: "to get (from somebody)(person に thing を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "覚える",
              kana: "おぼえる",
              romaji: "oboeru",
              english: "to memorize （~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "出る",
              kana: "でる",
              romaji: "deru",
              english: "(1) to appear; to attend (~に)(2)to exit (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "運動する",
              kana: "うんどうする",
              romaji: "undousuru",
              english: "to do physical exercises",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "散歩する",
              kana: "さんぽする",
              romaji: "sanposuru",
              english: "to take a walk",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "~から",
              romaji: "~kara",
              english: "from...",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "是非",
              kana: "ぜひ",
              romaji: "zehi",
              english: "by all means",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "ところで",
              romaji: "tokorode",
              english: "by the way",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "みんな",
              romaji: "minna",
              english: "all",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "もう",
              romaji: "mou",
              english: "already",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "一つ",
              kana: "ひとつ",
              romaji: "hitotsu",
              english: "one",
              type: "Numbers",
              correct: false,
            },
            {
              kanji: "二つ",
              kana: "ふたつ",
              romaji: "futatsu",
              english: "two",
              type: "Numbers",
              correct: false,
            },
            {
              kanji: "三つ",
              kana: "みっつ",
              romaji: "mittsu",
              english: "three",
              type: "Numbers",
              correct: false,
            },
            {
              kanji: "四つ",
              kana: "よっつ",
              romaji: "yottsu",
              english: "four",
              type: "Numbers",
              correct: false,
            },
            {
              kanji: "五つ",
              kana: "いつつ",
              romaji: "itsutsu",
              english: "five",
              type: "Numbers",
              correct: false,
            },
            {
              kanji: "六つ",
              kana: "むっつ",
              romaji: "muttsu",
              english: "six",
              type: "Numbers",
              correct: false,
            },
            {
              kanji: "七つ",
              kana: "ななつ",
              romaji: "nanatsu",
              english: "seven",
              type: "Numbers",
              correct: false,
            },
            {
              kanji: "八つ",
              kana: "やっつ",
              romaji: "yattsu",
              english: "eight",
              type: "Numbers",
              correct: false,
            },
            {
              kanji: "九つ",
              kana: "ここのつ",
              romaji: "kokonotsu",
              english: "nine",
              type: "Numbers",
              correct: false,
            },
            {
              kanji: "十",
              kana: "とお",
              romaji: "to-",
              english: "ten",
              type: "Numbers",
              correct: false,
            },
          ],
        },
        {
          id: 10,
          title: "Lesson 10",
          vocab: [
            {
              kanji: "秋",
              kana: "あき",
              romaji: "aki",
              english: "fall",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "医者",
              kana: "いしゃ",
              romaji: "isha",
              english: "doctor",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "駅",
              kana: "えき",
              romaji: "eki",
              english: "station",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お金持ち",
              kana: "おかねもち",
              romaji: "okanemochi",
              english: "rich person",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "顔",
              kana: "かお",
              romaji: "kao",
              english: "face",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "季節",
              kana: "きせつ",
              romaji: "kisetsu",
              english: "season",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "牛乳",
              kana: "ぎゅうにゅう",
              romaji: "gyuunyuu",
              english: "milk",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "クレジットカード",
              romaji: "kurejittoka-do",
              english: "credit card",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ケーキ",
              romaji: "ke-ki",
              english: "cake",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "今年",
              kana: "ことし",
              romaji: "kotoshi",
              english: "this year",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "サッカー",
              romaji: "sakka-",
              english: "soccer",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "シャツ",
              romaji: "shatsu",
              english: "shirt",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "新幹線",
              kana: "しんかんせん",
              romaji: "shinkansen",
              english: "Shinkansen; Bullet Train",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "すし",
              romaji: "sushi",
              english: "sushi",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "生活",
              kana: "せいかつ",
              romaji: "seikatsu",
              english: "life; living",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "世界",
              kana: "せかい",
              romaji: "sekai",
              english: "world",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "地下鉄",
              kana: "ちかてつ",
              romaji: "chikatetsu",
              english: "subway",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "手袋",
              kana: "てぶくろ",
              romaji: "tebukuro",
              english: "gloves",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "天ぷら",
              kana: "てんぷら",
              romaji: "tenpura",
              english: "tempura",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "床屋",
              kana: "とこや",
              romaji: "tokoya",
              english: "barber's",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "春",
              kana: "はる",
              romaji: "haru",
              english: "spring",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "パンツ",
              romaji: "pantsu",
              english: "pants",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "美容院",
              kana: "びよういん",
              romaji: "biyouin",
              english: "beauty parlor",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "便",
              kana: "びん",
              romaji: "bin",
              english: "flight",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "船",
              kana: "ふね",
              romaji: "fune",
              english: "ship; boat",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "野球",
              kana: "やきゅう",
              romaji: "yakyuu",
              english: "baseball",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "有名人",
              kana: "ゆうめいじん",
              romaji: "yuumeijinn",
              english: "celebrity",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "予約",
              kana: "よやく",
              romaji: "yoyaku",
              english: "reservation",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "来学期",
              kana: "らいがっき",
              romaji: "raigakki",
              english: "next semester",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "りんご",
              romaji: "ringo",
              english: "apple",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "暖かい",
              kana: "あたたかい",
              romaji: "atatakai",
              english: "warm",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "遅い",
              kana: "おそい",
              romaji: "osoi",
              english: "slow; late",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "涼しい",
              kana: "すずしい",
              romaji: "suzushii",
              english: "cool (weather - not used for things)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "冷たい",
              kana: "つめたい",
              romaji: "tsumetai",
              english: "cold (things/people)",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "眠い",
              kana: "ねむい",
              romaji: "nemui",
              english: "sleepy",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "簡単",
              kana: "かんたん(な)",
              romaji: "kantan(na)",
              english: "easy; simple",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: null,
              kana: "かかる",
              romaji: "kakaru",
              english: "to take (amount of time/moey) (no particle)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "泊まる",
              kana: "とまる",
              romaji: "tomaru",
              english: "to stay (at a hotel, etc.) (~に)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "なる",
              romaji: "naru",
              english: "to become",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "払う",
              kana: "はらう",
              romaji: "harau",
              english: "to pay (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "決める",
              kana: "きめる",
              romaji: "kimeru",
              english: "to deide (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "旅行する",
              kana: "りょこうする",
              romaji: "ryokousuru",
              english: "to travel",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "練習する",
              kana: "れんしゅうする",
              romaji: "renshuusuru",
              english: "to practice (~を)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "歩いて",
              kana: "あるいて",
              romaji: "aruite",
              english: "on foot",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "一番",
              kana: "いちばん",
              romaji: "ichiban",
              english: "best",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "~か~",
              romaji: "~ka~",
              english: "~or~",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "~か月",
              kana: "~かげつ",
              romaji: "~kagetsu",
              english: "for ...months",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "~後",
              kana: "~ご",
              romaji: "~go",
              english: "in... time; after...",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "このごろ",
              romaji: "konogoro",
              english: "these days",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "~週間",
              kana: "~しゅうかん",
              romaji: "~shuukan",
              english: "for...weeks",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "~で",
              romaji: "~de",
              english: "by (means of transportation); with (a tool)",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "どうやって",
              romaji: "douyatte",
              english: "how; by what means",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "どちら",
              romaji: "dochira",
              english: "which",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "どっち",
              romaji: "docchi",
              english: "which",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "どのぐらい",
              romaji: "donogurai",
              english: "how much; how long",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "~年",
              kana: "~ねん",
              romaji: "~nen",
              english: "...years",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "早く/速く",
              kana: "はやく",
              romaji: "hayaku",
              english: "(do something) early; fast",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
          ],
        },
        {
          id: 11,
          title: "Lesson 11",
          vocab: [
            {
              kanji: null,
              kana: "オーストラリア",
              romaji: "o-sutoraria",
              english: "Australia",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お菓子",
              kana: "おかし",
              romaji: "okashi",
              english: "snacks; sweets",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お正月",
              kana: "おしょうがつ",
              romaji: "oshougatsu",
              english: "New Year's",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "男の子",
              kana: "おとこのこ",
              romaji: "otokonoko",
              english: "boy",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お祭り",
              kana: "おまつり",
              romaji: "omatsuri",
              english: "festival",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "おもちゃ",
              romaji: "omocha",
              english: "toy",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "温泉",
              kana: "おんせん",
              romaji: "onsen",
              english: "spa; hot spring",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "女の子",
              kana: "おんなのこ",
              romaji: "onnanoko",
              english: "girl",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "外国",
              kana: "がいこく",
              romaji: "gaikoku",
              english: "foreign country",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "歌手",
              kana: "かしゅ",
              romaji: "kashu",
              english: "singer",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "川",
              kana: "かわ",
              romaji: "kawa",
              english: "river",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "キャンプ",
              romaji: "kyanpu",
              english: "camp",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "こちら",
              romaji: "kochira",
              english: "this person (polite)",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "今学期",
              kana: "こんがっき",
              romaji: "kongakki",
              english: "this semester",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "社長",
              kana: "しゃちょう",
              romaji: "shachou",
              english: "president of a company",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "授業",
              kana: "じゅぎょう",
              romaji: "jugyou",
              english: "class",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "将来",
              kana: "しょうらい",
              romaji: "shourai",
              english: "future",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "神社",
              kana: "じんじゃ",
              romaji: "jinja",
              english: "shrine",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "つり",
              romaji: "tsuri",
              english: "fishing",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ドライブ",
              romaji: "doraibu",
              english: "drive",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ビール",
              romaji: "bi-ru",
              english: "beer",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "美術館",
              kana: "びじゅつかん",
              romaji: "bijutsukan",
              english: "art museum",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ホストファミリー",
              romaji: "hosutofamiri-",
              english: "host family",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "湖",
              kana: "みずうみ",
              romaji: "mizuumi",
              english: "lake",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "山",
              kana: "やま",
              romaji: "yama",
              english: "mountain",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "夢",
              kana: "ゆめ",
              romaji: "yume",
              english: "dream",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ルームメイト",
              romaji: "ru-mumeito",
              english: "roommate",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "うそをつく",
              romaji: "uso o tsuku",
              english: "to tell a lie",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "おなかがすく",
              romaji: "onaka ga suku",
              english: "to become hungry",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "飼う",
              kana: "かう",
              romaji: "kau",
              english: "to own (a pet) (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "サボる",
              romaji: "saboru",
              english: "to cut (classes) (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "取る",
              kana: "とる",
              romaji: "toru",
              english: "to take (a class); to get (a grade) (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "習う",
              kana: "ならう",
              romaji: "narau",
              english: "to learn (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "登る",
              kana: "のぼる",
              romaji: "noboru",
              english: "to climb (place に)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "働く",
              kana: "はたらく",
              romaji: "hataraku",
              english: "to work",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "疲れる",
              kana: "つかれる",
              romaji: "tsukareru",
              english: "to get tired",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "やめる",
              romaji: "yameru",
              english: "to quit (~を)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "けんかする",
              romaji: "kenkasuru",
              english: "to have a fight; to quarrel",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "紹介する",
              kana: "しょうかいする",
              romaji: "shoukaisuru",
              english: "to introduce (person に person を)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "ダイエットする",
              romaji: "daiettosuru",
              english: "to go on a diet",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "遅刻する",
              kana: "ちこくする",
              romaji: "chikokusuru",
              english: "to be late (for an appointment) (~に)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "留学する",
              kana: "りゅうがくする",
              romaji: "ryuugakusuru",
              english: "to study abroad (place に)",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "後",
              kana: "あと",
              romaji: "ato",
              english: "after (an event) (event の)",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "出身",
              kana: "しゅっしん",
              romaji: "shusshin",
              english: "coming from (place の)",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "そして",
              romaji: "soshite",
              english: "and then",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "~だけ",
              romaji: "~dake",
              english: "just...; only...",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "~点",
              kana: "~てん",
              romaji: "~ten",
              english: "...points",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "久しぶり",
              kana: "ひさしぶり",
              romaji: "hisashiburi",
              english: "it has been a long time",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "まあまあ",
              romaji: "maamaa",
              english: "okay; so-so",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "もっと",
              romaji: "motto",
              english: "more",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "作家",
              kana: "さっか",
              romaji: "sakka",
              english: "writer",
              type: "Occupations",
              correct: false,
            },
            {
              kanji: "女優",
              kana: "じょゆう",
              romaji: "joyuu",
              english: "actress",
              type: "Occupations",
              correct: false,
            },
            {
              kanji: null,
              kana: "ジャーナリスト",
              romaji: "ja-narisuto",
              english: "journalist",
              type: "Occupations",
              correct: false,
            },
            {
              kanji: "看護師",
              kana: "かんごし",
              romaji: "kangoshi",
              english: "nurse",
              type: "Occupations",
              correct: false,
            },
            {
              kanji: "警察官",
              kana: "けいさつかん",
              romaji: "keisatsukan",
              english: "police officer",
              type: "Occupations",
              correct: false,
            },
            {
              kanji: "消防士",
              kana: "しょうぼうし",
              romaji: "shouboushi",
              english: "firefighter",
              type: "Occupations",
              correct: false,
            },
            {
              kanji: "俳優",
              kana: "はいゆう",
              romaji: "haiyuu",
              english: "actor; actress",
              type: "Occupations",
              correct: false,
            },
            {
              kanji: "漫画家",
              kana: "まんがか",
              romaji: "mangaka",
              english: "cartoonist",
              type: "Occupations",
              correct: false,
            },
            {
              kanji: "宇宙飛行士",
              kana: "うちゅうひこうし",
              romaji: "uchuuhikoushi",
              english: "astronaut",
              type: "Occupations",
              correct: false,
            },
            {
              kanji: "野球選手",
              kana: "やきゅうせんしゅ",
              romaji: "yakyuusenshu",
              english: "baseball player",
              type: "Occupations",
              correct: false,
            },
            {
              kanji: "大統領",
              kana: "だいとうりょう",
              romaji: "daitouryou",
              english: "president of a country",
              type: "Occupations",
              correct: false,
            },
          ],
        },
        {
          id: 12,
          title: "Lesson 12",
          vocab: [
            {
              kanji: "足",
              kana: "あし",
              romaji: "ashi",
              english: "leg; foot",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "意味",
              kana: "いみ",
              romaji: "imi",
              english: "meaning",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "お手洗い",
              kana: "おてあらい",
              romaji: "otearai",
              english: "restroom",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "おなか",
              romaji: "onaka",
              english: "stomach",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "風邪",
              kana: "かぜ",
              romaji: "kaze",
              english: "cold",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "彼女",
              kana: "かのじょ",
              romaji: "kanojo",
              english: "girlfriend; she",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "彼",
              kana: "かれ",
              romaji: "kare",
              english: "boyfriend; he",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "気温",
              kana: "きおん",
              romaji: "kion",
              english: "temperature (weather - not used for things)",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "曇り",
              kana: "くもり",
              romaji: "kumori",
              english: "cloudy weather",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "試合",
              kana: "しあい",
              romaji: "shiai",
              english: "match; game",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ジュース",
              romaji: "ju-su",
              english: "juice",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "政治",
              kana: "せいじ",
              romaji: "seiji",
              english: "politics",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "成績",
              kana: "せいせき",
              romaji: "seiseki",
              english: "grade (on a test, etc.)",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "せき",
              romaji: "seki",
              english: "cough",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "のど",
              romaji: "nodo",
              english: "throat",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "歯",
              kana: "は",
              romaji: "ha",
              english: "tooth",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "花",
              kana: "はな",
              romaji: "hana",
              english: "flower",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "晴れ",
              kana: "はれ",
              romaji: "hare",
              english: "sunny weather",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "服",
              kana: "ふく",
              romaji: "fuku",
              english: "clothes",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "二日酔い",
              kana: "ふつかよい",
              romaji: "futsukayoi",
              english: "hangover",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "プレゼント",
              romaji: "purezento",
              english: "present",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "ホームシック",
              romaji: "ho-mushikku",
              english: "homesickness",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: null,
              kana: "マイナス",
              romaji: "mainasu",
              english: "minus",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "物",
              kana: "もの",
              romaji: "mono",
              english: "thing (concrete object)",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "雪",
              kana: "ゆき",
              romaji: "yuki",
              english: "snow",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "用事",
              kana: "ようじ",
              romaji: "youji",
              english: "business to take care of",
              type: "Nouns",
              correct: false,
            },
            {
              kanji: "甘い",
              kana: "あまい",
              romaji: "amai",
              english: "sweet",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "痛い",
              kana: "いたい",
              romaji: "itai",
              english: "hurt; painful",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "多い",
              kana: "おおい",
              romaji: "ooi",
              english: "There are many...",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "狭い",
              kana: "せまい",
              romaji: "semai",
              english: "narrow; not spacious",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "都合が悪い",
              kana: "つごうがわるい",
              romaji: "tsugou ga warui",
              english: "inconvenient; to have a scheduling conflict",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "悪い",
              kana: "わるい",
              romaji: "warui",
              english: "bad",
              type: "い-Adjectives",
              correct: false,
            },
            {
              kanji: "素敵",
              kana: "すてき(な)",
              romaji: "suteki(na)",
              english: "nice",
              type: "な-Adjectives",
              correct: false,
            },
            {
              kanji: "歩く",
              kana: "あるく",
              romaji: "aruku",
              english: "to walk",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "風邪をひく",
              kana: "かぜをひく",
              romaji: "kaze o hiku",
              english: "to catch a cold",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "興味がある",
              kana: "きょうみがある",
              romaji: "kyoumi ga aru",
              english: "to be interested (in …) (topic に)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: null,
              kana: "なくす",
              romaji: "nakusu",
              english: "to lose (~を)",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "熱がある",
              kana: "ねつがある",
              romaji: "netsu ga aru",
              english: "to have a fever",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "のどが渇く",
              kana: "のどがかわく",
              romaji: "nodo ga kawaku",
              english: "to become thirsty",
              type: "U-Verbs",
              correct: false,
            },
            {
              kanji: "せきが出る",
              kana: "せきがでる",
              romaji: "seki ga deru",
              english: "to cough",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "別れる",
              kana: "わかれる",
              romaji: "wakareru",
              english: "to break up; to separate (person と)",
              type: "Ru-Verbs",
              correct: false,
            },
            {
              kanji: "緊張する",
              kana: "きんちょうする",
              romaji: "kinnchousuru",
              english: "to get nervous",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "心配する",
              kana: "しんぱいする",
              romaji: "shinpaisuru",
              english: "to worry",
              type: "Irregular Verbs",
              correct: false,
            },
            {
              kanji: "お大事に",
              kana: "おだいじに",
              romaji: "odaijini",
              english: "Get well soon.",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "元気がない",
              kana: "げんきがない",
              romaji: "genki ga nai",
              english: "don't look well",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "多分",
              kana: "たぶん",
              romaji: "tabun",
              english: "probably; maybe",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "できるだけ",
              romaji: "dekirudake",
              english: "as much as possible",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "~でしょう",
              romaji: "~deshou",
              english: "probably; ...,right?",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "~度",
              kana: "~ど",
              romaji: "~do",
              english: "~degrees (temperature)",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "二三日",
              kana: "にさんにち",
              romaji: "nisannichi",
              english: "for two to three days",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "~ので",
              romaji: "~node",
              english: "because...",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: "初めて",
              kana: "はじめて",
              romaji: "hajimete",
              english: "for the first time",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
            {
              kanji: null,
              kana: "もうすぐ",
              romaji: "mousugu",
              english: "very soon; in a few moments/days",
              type: "Adverbs and Other Expressions",
              correct: false,
            },
          ],
        },
        {
          id: 24,
          title: "Hiragana",
          vocab: [
            {
              kanji: null,
              kana: "あ",
              romaji: "a",
              english: "a",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "い",
              romaji: "i",
              english: "i",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "う",
              romaji: "u",
              english: "u",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "え",
              romaji: "e",
              english: "e",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "お",
              romaji: "o",
              english: "o",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "か",
              romaji: "ka",
              english: "ka",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "き",
              romaji: "ki",
              english: "ki",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "く",
              romaji: "ku",
              english: "ku",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "け",
              romaji: "ke",
              english: "ke",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "こ",
              romaji: "ko",
              english: "ko",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "さ",
              romaji: "sa",
              english: "sa",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "し",
              romaji: "shi",
              english: "shi",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "す",
              romaji: "su",
              english: "su",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "せ",
              romaji: "se",
              english: "se",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "そ",
              romaji: "so",
              english: "so",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "た",
              romaji: "ta",
              english: "ta",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ち",
              romaji: "chi",
              english: "chi",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "つ",
              romaji: "tsu",
              english: "tsu",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "て",
              romaji: "te",
              english: "te",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "と",
              romaji: "to",
              english: "to",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "な",
              romaji: "na",
              english: "na",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ぬ",
              romaji: "nu",
              english: "nu",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ね",
              romaji: "ne",
              english: "ne",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "の",
              romaji: "no",
              english: "no",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "に",
              romaji: "ni",
              english: "ni",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "は",
              romaji: "ha",
              english: "ha",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ひ",
              romaji: "hi",
              english: "hi",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ふ",
              romaji: "fu",
              english: "fu",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "へ",
              romaji: "he",
              english: "he",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ほ",
              romaji: "ho",
              english: "ho",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "や",
              romaji: "ya",
              english: "ya",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ゆ",
              romaji: "yu",
              english: "yu",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "よ",
              romaji: "yo",
              english: "yo",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ら",
              romaji: "ra",
              english: "ra",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "り",
              romaji: "ri",
              english: "ri",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "る",
              romaji: "ru",
              english: "ru",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "れ",
              romaji: "re",
              english: "re",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ろ",
              romaji: "ro",
              english: "ro",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "わ",
              romaji: "wa",
              english: "wa",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "を",
              romaji: "wo",
              english: "wo",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ん",
              romaji: "n",
              english: "n",
              type: null,
              correct: false,
            },
          ],
        },
        {
          id: 25,
          title: "Katakana",
          vocab: [
            {
              kanji: null,
              kana: "ア",
              romaji: "a",
              english: "a",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "イ",
              romaji: "i",
              english: "i",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ウ",
              romaji: "u",
              english: "u",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "エ",
              romaji: "e",
              english: "e",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "オ",
              romaji: "o",
              english: "o",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "カ",
              romaji: "ka",
              english: "ka",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "キ",
              romaji: "ki",
              english: "ki",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ク",
              romaji: "ku",
              english: "ku",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ケ",
              romaji: "ke",
              english: "ke",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "コ",
              romaji: "ko",
              english: "ko",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "サ",
              romaji: "sa",
              english: "sa",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "シ",
              romaji: "shi",
              english: "shi",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ス",
              romaji: "su",
              english: "su",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "セ",
              romaji: "se",
              english: "se",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ソ",
              romaji: "so",
              english: "so",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "タ",
              romaji: "ta",
              english: "ta",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "チ",
              romaji: "chi",
              english: "chi",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ツ",
              romaji: "tsu",
              english: "tsu",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "テ",
              romaji: "te",
              english: "te",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ト",
              romaji: "to",
              english: "to",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ナ",
              romaji: "na",
              english: "na",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ヌ",
              romaji: "nu",
              english: "nu",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ネ",
              romaji: "ne",
              english: "ne",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ノ",
              romaji: "no",
              english: "no",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ニ",
              romaji: "ni",
              english: "ni",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ハ",
              romaji: "ha",
              english: "ha",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ヒ",
              romaji: "hi",
              english: "hi",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "フ",
              romaji: "fu",
              english: "fu",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ヘ",
              romaji: "he",
              english: "he",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ホ",
              romaji: "ho",
              english: "ho",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ヤ",
              romaji: "ya",
              english: "ya",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ユ",
              romaji: "yu",
              english: "yu",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ヨ",
              romaji: "yo",
              english: "yo",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ラ",
              romaji: "ra",
              english: "ra",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "リ",
              romaji: "ri",
              english: "ri",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ル",
              romaji: "ru",
              english: "ru",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "レ",
              romaji: "re",
              english: "re",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ロ",
              romaji: "ro",
              english: "ro",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ワ",
              romaji: "wa",
              english: "wa",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ヲ",
              romaji: "wo",
              english: "wo",
              type: null,
              correct: false,
            },
            {
              kanji: null,
              kana: "ン",
              romaji: "n",
              english: "n",
              type: null,
              correct: false,
            },
          ],
        },
      ],
    },
  ],
};
